<template>
  <div class="background_container_ipad">
    <div class="mobile_view_container">
      <LoginMobile />
    </div>
  </div>
</template>

<script>
import LoginMobile from "./LoginMobile.vue";
export default {
  name: "LoginIpad",
  components: { LoginMobile },
};
</script>

<style lang="scss">
// 540px to handle surface duo
@media all and (max-width: 1024px) and (min-width:541px) {
  .background_container_ipad {
    background-color: #115e67;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    .mobile_view_container {
      width: 524px;
      height: 835px;
      margin-top: 30px;
      .background_container_mobile {
        .page_header_login {
          justify-content: left !important;
          border-radius: 11px 11px 0px 0px;
          img {
            width: 21% !important;
            height: 111px !important;
          }
          #double_png {
            width: 42% !important;
            border-radius: 11px 0px 0px 0px;
          }
        }
        .login_form_mobile {
          border-radius: 0px 0px 11px 11px;
          #welcome_text {
            font-size: 33px !important;
          }
        }
        .login_footer {
          height: 100px;
        }
      }
    }
  }
}
@media all and (max-width:540px) {
    .login-iPad-container{
        height: 100%;
        .mobile_view_container{
            width: 100%;
        }
    }
}
</style>
